import { render, staticRenderFns } from "./update-player.vue?vue&type=template&id=d936b566&"
import script from "./update-player.vue?vue&type=script&lang=js&"
export * from "./update-player.vue?vue&type=script&lang=js&"
import style0 from "./update-player.vue?vue&type=style&index=0&id=d936b566&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports